import { render, staticRenderFns } from "./DuesComment.vue?vue&type=template&id=91aa7420&scoped=true"
import script from "./DuesComment.vue?vue&type=script&lang=js"
export * from "./DuesComment.vue?vue&type=script&lang=js"
import style0 from "./DuesComment.vue?vue&type=style&index=0&id=91aa7420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91aa7420",
  null
  
)

export default component.exports